import dynamic from 'next/dynamic';
import { Widget } from '../../../../apiService';
import type { TeaserHeaderInfo } from './TeaserVideo';

const TeaserVideo = dynamic(() => import('./TeaserVideo'));

const TeaserVideoWidget = ({ widget, headerInfo }: { widget: Widget<'live_channel'>; headerInfo?: TeaserHeaderInfo }) => {
  const {
    configuration: { items },
    display_title,
  } = widget;

  return <TeaserVideo items={items} displayTitle={display_title} compact={headerInfo?.compact} />;
};

export default TeaserVideoWidget;
